import {
  Node,
  updateHashByPath,
} from './merkle_tree.js';

// imutable merkle tree
/**
 *
 * Node = {
 *   data,
 *   children,
 *   hash,
 * }
 *
 * hash(node) = hash(data) + for all child in childs: hash(child)
 *
 * if hash(n1) == hash(n2), then n1 and n2 are the same tree
 */

const ImmutableMerkleTree = function(root) {
  this.root = root;
};

ImmutableMerkleTree.prototype = {
  // path = [0, 1, 2, ...]
  // return a new merkle tree
  appendData: function(path, data) {
    const newImmutableMerkleTree = this.createNewImmutableMerkleTreeByPath(path);

    // find node
    const node = newImmutableMerkleTree.root.findNodeByPath(path);

    // create new child
    const child = new Node(data);

    // append
    node.appendChild(child);

    // update hash
    updateHashByPath(newImmutableMerkleTree.root, path);

    return newImmutableMerkleTree;
  },

  removeChildAt: function(path) {
    if (!path.length) {
      throw new Error('path is empty');
    }
    const newImmutableMerkleTree = this.createNewImmutableMerkleTreeByPath(path);

    // find node
    const node = newImmutableMerkleTree.root.findNodeByPath(path.slice(0, path.length - 1));

    // remove child
    node.removeChildByIndex(path[path.length - 1]);

    // update hash
    updateHashByPath(newImmutableMerkleTree.root, path);

    return newImmutableMerkleTree;
  },

  removeAllChildren: function(path) {
    const newImmutableMerkleTree = this.createNewImmutableMerkleTreeByPath(path);
    // find node
    const node = newImmutableMerkleTree.root.findNodeByPath(path);

    // remove
    node.removeAllChildren(child);

    // update hash
    updateHashByPath(newImmutableMerkleTree.root, path);

    return newImmutableMerkleTree;
  },

  updateData: function(path, newData) {
    const newImmutableMerkleTree = this.createNewImmutableMerkleTreeByPath(path);
    // find node
    const node = newImmutableMerkleTree.root.findNodeByPath(path);
    node.updateData(newData);

    // update hash
    updateHashByPath(newImmutableMerkleTree.root, path);

    return newImmutableMerkleTree;
  },

  createNewImmutableMerkleTreeByPath: function(path) {
    // create a new merkle tree
    const newMerkleRoot = this.createNewMerkleTreeByPath(path);
    const newImmutableMerkleTree = new ImmutableMerkleTree(newMerkleRoot);
    return newImmutableMerkleTree;
  },

  createNewMerkleTreeByPath: function(path) {
    const newRoot = this.root.clone();
    let cur = newRoot;

    for (let i = 0; i < path.length; i++) {
      const next = cur.getChildByIndex(path[i]).clone();
      cur.replaceChildByIndex(path[i], next);
      cur = next;
    }

    return newRoot;
  },

  getHash: function() {
    return this.root.getHash();
  },

  getDataByPath: function(path) {
    const node = this.root.findNodeByPath(path);
    return node.data;
  },

  getChildrenSize: function(path) {
    const node = this.root.findNodeByPath(path);
    return node.children.length;
  },
};

export {
  ImmutableMerkleTree
};
